import { render, staticRenderFns } from "./cellHeight-editor.vue?vue&type=template&id=addf4628&scoped=true"
import script from "./cellHeight-editor.vue?vue&type=script&lang=js"
export * from "./cellHeight-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addf4628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('addf4628')) {
      api.createRecord('addf4628', component.options)
    } else {
      api.reload('addf4628', component.options)
    }
    module.hot.accept("./cellHeight-editor.vue?vue&type=template&id=addf4628&scoped=true", function () {
      api.rerender('addf4628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-table-cell/cellHeight-editor.vue"
export default component.exports